import { render, staticRenderFns } from "./BasePartnerLogo.vue?vue&type=template&id=db28bbac&scoped=true&"
import script from "./BasePartnerLogo.vue?vue&type=script&lang=js&"
export * from "./BasePartnerLogo.vue?vue&type=script&lang=js&"
import style0 from "./BasePartnerLogo.vue?vue&type=style&index=0&id=db28bbac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db28bbac",
  null
  
)

export default component.exports